'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getCategory(this.$stateParams.id)
  }

  getCategory(id) {
    this.$http.get(`/api/categories/${id}`).then(response => {
      this.category = response.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete('/api/categories/' + id).then(response => {
        this.getCategory(this.category._id);
      });
    }
  }

  addChild() {
    if (!this.name.trim()) {
        alert("名称不能为空")
    }
    let data = {
      name: this.name,
      parent: this.category._id
    };
    this.$http.post('/api/categories', data).then(res => {
      this.getCategory(this.category._id);
    })
  }

}



// WEBPACK FOOTER //
// ./client/app/categories/show/show.controller.js